module.exports = __webpack_public_path__ + "310c79cee2d436a773f3204f134bb652.woff";